import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthserviceService } from '../../core/services/authservice.service';
import { AdminCountersService } from '../../core/services/admin-counters.service';
import { ChatUnreadSessionService } from '../../core/services/chat-unread-session.service';

@Component({
    selector: 'app-admin-layout',
    templateUrl: './admin-layout.component.html',
    styleUrls: ['./admin-layout.component.css'],
    standalone: false
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  readonly spinnerName = 'adminLayoutSpinner';
  isSidebarCollapsed = false;
  private sidebarMql?: MediaQueryList;
  private sidebarMqlListener?: (event: MediaQueryListEvent) => void;

  constructor(
    private spinner: NgxSpinnerService,
    private authservice: AuthserviceService,
    private adminCounters: AdminCountersService,
    private chatUnreadSession: ChatUnreadSessionService
  ) {}

  get userName(): string {
    return this.authservice.usuarioValue?.usuario ?? 'Administrador';
  }

  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  ngOnInit(): void {
    this.chatUnreadSession.start();
    this.adminCounters.start();
    this.spinner.show(this.spinnerName);
    setTimeout(() => this.spinner.hide(this.spinnerName), 0);
    if (typeof window !== 'undefined') {
      this.sidebarMql = window.matchMedia('(max-width: 900px)');
      this.isSidebarCollapsed = this.sidebarMql.matches;
      this.sidebarMqlListener = (event: MediaQueryListEvent) => {
        this.isSidebarCollapsed = event.matches;
      };
      this.sidebarMql.addEventListener('change', this.sidebarMqlListener);
    }
  }

  ngOnDestroy(): void {
    this.adminCounters.stop();
    this.chatUnreadSession.stop();
    if (this.sidebarMql && this.sidebarMqlListener) {
      this.sidebarMql.removeEventListener('change', this.sidebarMqlListener);
    }
  }
}
